/** ستون عملیات ثابت در انتهای جداول ماژول کار */
export const workActionsColumn = (render, width = 140) => ({
  title: 'عملیات',
  key: 'actions',
  fixed: 'right',
  width,
  align: 'center',
  render,
});
